<goalmate-navbar />
<router-outlet></router-outlet>

<!-- TODO: remove these components -->
<!-- <goalmate-wait-list></goalmate-wait-list> -->
<!-- <goalmate-featured-on></goalmate-featured-on> -->
